export default __webpack_public_path__ + "static/media/pending-aum.60e3bd8d.svg";